import {
	DateOfRegistrationField,
	EncumbranceTypeField,
	InstrumentAmountField,
	InstrumentNumberField,
	PartyFromField,
	PartyToField,
	RequisitionPrecedentIds,
	TeranetRequisitionTypes,
} from './requisitions';

export const TeranetRequisitionTypesToRequisitionId = {
	[TeranetRequisitionTypes.CHARGE]: RequisitionPrecedentIds.CHARGE,
	[TeranetRequisitionTypes.NOTICE]:
		RequisitionPrecedentIds.NOTICE_OF_SECURITY_INTEREST,
	[TeranetRequisitionTypes.LIEN]: RequisitionPrecedentIds.LIEN,
	[TeranetRequisitionTypes.CAUTION]: RequisitionPrecedentIds.CAUTION_CHARGE,
	[TeranetRequisitionTypes.RESTRICTIVE_COVENANTS]:
		RequisitionPrecedentIds.RESTRICTIVE_COVENANTS_ON_TITLE,
};

export const TeranetRequisionFieldsToRequisitionPrecedentFieldName = {
	amount: InstrumentAmountField.name,
	parties_from: PartyFromField.name,
	parties_to: PartyToField.name,
	reg_date: DateOfRegistrationField.name,
	reg_number: InstrumentNumberField.name,
	type: EncumbranceTypeField.name,
};
